import { useMutation } from '@tanstack/react-query';
import { postAppointment } from '../api/repository/appointment';
import { CreateAppointmentInterface } from '../types/appointment';

type PostAppointmentProps = {
    createAppointment: CreateAppointmentInterface;
};

export const usePostAppointment = () => {
    return useMutation({
        mutationFn: ({ createAppointment }: PostAppointmentProps) =>
            postAppointment(createAppointment),
    });
};
